import React, { Component } from 'react';
import ActiveScrollSelect from '../../component/mui/select/active-scroll-select.jsx';
import { formatMessage } from '../../intl/helper';
import confirmText from '../../intl/messages/button';
import './floating-scroll-selector.scss';

export default class FloatingScrollSelector extends Component {
  static propTypes = {
    dataList: React.PropTypes.array,
    defaultCheckedIndex: React.PropTypes.number,
    selectorTitle: React.PropTypes.string.isRequired,
    optionComponent: React.PropTypes.func.isRequired,

    toggleSelectorCheckedStatus: React.PropTypes.func.isRequired,
    setSelectedOption: React.PropTypes.func.isRequired,
    closeSelector: React.PropTypes.func.isRequired,
  };

  static defaultProps = {
    defaultCheckedIndex: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      activedOption: null,
    };

    this.confirmSelecting = this.confirmSelecting.bind(this);
  }

  componentWillMount() {
    const {
      dataList,
      toggleSelectorCheckedStatus,
      defaultCheckedIndex,
    } = this.props;

    if (dataList && dataList.length > 0) {
      toggleSelectorCheckedStatus(
        defaultCheckedIndex <= 0 ? 0 : defaultCheckedIndex,
      );
    }
  }

  componentWillReceiveProps(nextProp) {
    const { dataList } = nextProp;
    const { activedOption } = this.state;
    if (Array.isArray(dataList)) {
      const checkedItem = dataList.find(item => item.isChecked);
      if (!!checkedItem && !activedOption) {
        this.setState(() => ({ activedOption: checkedItem }));
      }
    }
  }

  checkActiveOption(option) {
    const { dataList, toggleSelectorCheckedStatus } = this.props;

    dataList.forEach((item, index) => {
      if (item.id === option.id) {
        if (!item.isChecked) {
          toggleSelectorCheckedStatus(index);
          this.setState(() => ({ activedOption: item }));
        }
      }
    });
  }

  confirmSelecting(e) {
    const {
      closeSelector,
      setSelectedOption,
      defaultCheckedIndex,
      dataList,
    } = this.props;
    const { activedOption } = this.state;

    setSelectedOption(activedOption || dataList[defaultCheckedIndex]);
    closeSelector(e);
  }

  createSelectorOptions() {
    const { dataList, optionComponent } = this.props;

    return (
      <div className="o-flex">
        <ActiveScrollSelect
          className="row-floating-select"
          optionsData={dataList}
          optionComponent={optionComponent}
          onSelectOption={(event, option) => this.checkActiveOption(option)}
        />
      </div>
    );
  }

  render() {
    const selectorOptions = this.createSelectorOptions();
    const { closeSelector, selectorTitle } = this.props;

    return (
      <div
        className="scroll-select-container floating-select-container"
        tabIndex="-1"
      >
        <div className="scroll-select-close" onTouchTap={closeSelector} />
        <div className="scroll-select-content">
          <div className="scroll-select-header">
            <span>{selectorTitle}</span>
            <div
              className="scroll-select-confirm btn--yellow"
              onTouchTap={this.confirmSelecting}
            >
              {formatMessage(confirmText.sure)}
            </div>
          </div>
          {selectorOptions}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/common/floating-scroll-selector.jsx